import { useState, useCallback, useMemo } from 'react';

export const useLimitedTrigger = (key: string, limit = 2, duration = 12 * 60 * 60 * 1000) => {
  const [, setCount] = useState(
    typeof localStorage !== 'undefined' ? parseInt(localStorage.getItem(`${key}_count`) || '0') : 0
  );
  const initialEnable = useMemo(() => {
    if (typeof localStorage === 'undefined') return false;
    const storedCount = parseInt(localStorage.getItem(`${key}_count`) || '0');
    const storedTimestamp = parseInt(localStorage.getItem(`${key}_timestamp`) || '0');

    // Calculate time difference since last trigger
    const currentTime = Date.now();
    const timeDifference = currentTime - storedTimestamp;

    // If time difference is greater than duration, reset count and enable
    if (timeDifference >= duration) {
      setCount(0);
      localStorage.setItem(`${key}_count`, '' + 0);
      localStorage.setItem(`${key}_timestamp`, '' + currentTime);
      return true;
    } else {
      return storedCount < limit;
    }
  }, [duration, key, limit]);

  const [enabled, setEnabled] = useState(initialEnable);

  const triggerFunction = useCallback(() => {
    if (enabled) {
      setCount((count) => {
        const newCount = count + 1;
        localStorage.setItem(`${key}_count`, '' + newCount);
        localStorage.setItem(`${key}_timestamp`, '' + Date.now());

        if (newCount >= limit) {
          setEnabled(false);
        }

        return newCount;
      });
    }
  }, [enabled, key, limit]);

  return [triggerFunction, enabled] as [() => void, boolean];
};
